var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EAF0F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_206_9292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.364 24.4694C26.0712 24.1765 25.5963 24.1765 25.3034 24.4694C25.0105 24.7623 25.0105 25.2372 25.3034 25.5301L26.364 24.4694ZM28.6366 28.8634C28.9295 29.1563 29.4044 29.1563 29.6973 28.8634C29.9902 28.5705 29.9902 28.0956 29.6973 27.8027L28.6366 28.8634ZM25.3034 25.5301L28.6366 28.8634L29.6973 27.8027L26.364 24.4694L25.3034 25.5301ZM19.167 25.083C15.4391 25.083 12.417 22.0609 12.417 18.333H10.917C10.917 22.8894 14.6106 26.583 19.167 26.583V25.083ZM25.917 18.333C25.917 22.0609 22.8949 25.083 19.167 25.083V26.583C23.7233 26.583 27.417 22.8894 27.417 18.333H25.917ZM19.167 11.583C22.8949 11.583 25.917 14.6051 25.917 18.333H27.417C27.417 13.7767 23.7233 10.083 19.167 10.083V11.583ZM19.167 10.083C14.6106 10.083 10.917 13.7767 10.917 18.333H12.417C12.417 14.6051 15.4391 11.583 19.167 11.583V10.083Z",
    fill: "#A4A8AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_9292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "EAF0F8",
    transform: "translate(10 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a0a45f28c77d73d9a9f2c13a60c5bbb7.svg";
export { ForwardRef as ReactComponent };